import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "D:/data/pc_data/firma/0_kunden/Wenke/new-website/src/components/layout.js";
import { Container } from '../components/container';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Container mdxType="Container">
      <h1>{`IMPRESSUM`}</h1>
      <h2>{`ANGABEN GEMÄSS § 5 TMG`}</h2>
      <p>{`Wenke Reichert | Zeitschenkerin`}<br parentName="p"></br>{`
`}{`Wenke Reichert`}<br parentName="p"></br>{`
`}{`Im Willstein 33`}<br parentName="p"></br>{`
`}{`57319 Bad Berleburg`}</p>
      <h2>{`KONTAKT`}</h2>
      <p>{`Telefon: +49 (0) 163 566 61 11`}<br parentName="p"></br>{`
`}{`E-Mail: `}<a parentName="p" {...{
          "href": "mailto:info@wenke-reichert.de"
        }}>{`info@wenke-reichert.de`}</a></p>
      <h2>{`UMSATZSTEUER-ID`}</h2>
      <p>{`Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:`}<br parentName="p"></br>{`
`}{`DE 326 541 989`}</p>
      <h2>{`VERBRAUCHER­STREIT­BEILEGUNG`}{`​`}{`/`}{`​`}{`UNIVERSAL`}{`​`}{`SCHLICHTUNGS`}{`​`}{`STELLE`}</h2>
      <p>{`Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.`}</p>
      <h3>{`HAFTUNG FÜR INHALTE`}</h3>
      <p>{`Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.`}</p>
      <p>{`Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.`}</p>
      <h3>{`URHEBERRECHT`}</h3>
      <p>{`Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.`}</p>
      <p>{`Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.`}</p>
      <p>{`Quelle: `}<a parentName="p" {...{
          "href": "https://www.e-recht24.de/impressum-generator.html"
        }}>{`https://www.e-recht24.de/impressum-generator.html`}</a></p>
      <h3>{`ICONS`}</h3>
      <p>{`Einige Icons wurden von Font Awesome (`}<a parentName="p" {...{
          "href": "https://fontawesome.com/license"
        }}>{`https://fontawesome.com/license`}</a>{`) zur Verfügung gestellt.`}</p>
      <h3>{`BILDNACHWEIS`}</h3>
      <p>{`Portraitfotografie: Tina Lamping – `}<a parentName="p" {...{
          "href": "https://tinalamping.de/"
        }}>{`tinalamping.de`}</a></p>
      <h3>{`WEBDESIGN`}</h3>
      <p>{`Webdesign und Webentwicklung - `}<a parentName="p" {...{
          "href": "https://davidlangheiter.com"
        }}>{`David Langheiter`}</a></p>
    </Container>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      